import styled from 'styled-components';

import { Toggle as BreweryToggle } from '@xing-com/toggle';

export const Toggle = styled(BreweryToggle)`
  flex-shrink: 0;
`;
